import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faExclamationTriangle,
  faExclamationCircle,
  faCloudDownloadAlt,
  faExternalLinkAlt,
  faCloudUploadAlt,
  faQuestionCircle,
  faSortAmountDown,
  faChevronRight,
  faFileDownload,
  faCalendarAlt,
  faCalendarDay,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faFileArchive,
  faMinusCircle,
  faTimesCircle,
  faAngleRight,
  faFileUpload,
  faInfoCircle,
  faLayerGroup,
  faPlusCircle,
  faSignOutAlt,
  faThumbsDown,
  faUserCircle,
  faVolumeMute,
  faUserSlash,
  faAngleDown,
  faAngleLeft,
  faCaretDown,
  faEllipsisV,
  faPencilAlt,
  faThumbtack,
  faUserMinus,
  faBookOpen,
  faChartBar,
  faDatabase,
  faDownload,
  faEnvelope,
  faEyeSlash,
  faShareAlt,
  faSlidersH,
  faThumbsUp,
  faUserPlus,
  faVolumeUp,
  faAngleUp,
  faCaretUp,
  faComment,
  faFileAlt,
  faGamepad,
  faRedoAlt,
  faSyncAlt,
  faUnlock,
  faCircle,
  faFilter,
  faImages,
  faSearch,
  faServer,
  faTrophy,
  faUpload,
  faWallet,
  faCheck,
  faClock,
  faCubes,
  faImage,
  faMinus,
  faTimes,
  faTrash,
  faUsers,
  faCode,
  faEdit,
  faFile,
  faFlag,
  faHome,
  faInfo,
  faLink,
  faList,
  faLock,
  faPlus,
  faStar,
  faTags,
  faUser,
  faBook,
  faBug,
  faCog,
  faEye,
  faKey,
  faPen,
  faTag,
} from '@fortawesome/free-solid-svg-icons'
import {
  faFacebookSquare,
  faTwitterSquare,
  faGithubSquare,
  faRedditAlien,
  faSteamSymbol,
  faPlaystation,
  faFacebook,
  faDiscord,
  faTwitter,
  faYoutube,
  faGoogle,
  faItchIo,
  faGithub,
  faPaypal,
  faXbox,
} from '@fortawesome/free-brands-svg-icons'
import {
  faTimesCircle as farTimeCircle,
  faEdit as farEdit,
  faMoon as farMoon,
  faEye as farEye,
} from '@fortawesome/free-regular-svg-icons'

const brandIcons = [
  faDiscord,
  faFacebook,
  faFacebookSquare,
  faGithubSquare,
  faGoogle,
  faItchIo,
  faRedditAlien,
  faSteamSymbol,
  faTwitter,
  faTwitterSquare,
  faXbox,
  faYoutube,
  faPlaystation,
  faGithub,
  faPaypal,
]

const regularIcons = [farTimeCircle, farEdit, farEye, farMoon]

const solidIcons = [
  faExclamationTriangle,
  faExclamationCircle,
  faCloudDownloadAlt,
  faExternalLinkAlt,
  faCloudUploadAlt,
  faQuestionCircle,
  faSortAmountDown,
  faChevronRight,
  faFileDownload,
  faCalendarAlt,
  faCalendarDay,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faFileArchive,
  faMinusCircle,
  faTimesCircle,
  faAngleRight,
  faFileUpload,
  faInfoCircle,
  faLayerGroup,
  faPlusCircle,
  faSignOutAlt,
  faThumbsDown,
  faUserCircle,
  faVolumeMute,
  faUserSlash,
  faAngleDown,
  faAngleLeft,
  faCaretDown,
  faEllipsisV,
  faPencilAlt,
  faThumbtack,
  faUserMinus,
  faBookOpen,
  faChartBar,
  faDatabase,
  faDownload,
  faEnvelope,
  faEyeSlash,
  faShareAlt,
  faSlidersH,
  faThumbsUp,
  faUserPlus,
  faVolumeUp,
  faAngleUp,
  faCaretUp,
  faComment,
  faFileAlt,
  faGamepad,
  faRedoAlt,
  faSyncAlt,
  faCircle,
  faFilter,
  faUnlock,
  faImages,
  faSearch,
  faServer,
  faTrophy,
  faUpload,
  faWallet,
  faCheck,
  faClock,
  faCubes,
  faImage,
  faMinus,
  faTimes,
  faTrash,
  faUsers,
  faCode,
  faEdit,
  faFile,
  faFlag,
  faHome,
  faInfo,
  faLink,
  faList,
  faLock,
  faPlus,
  faStar,
  faTags,
  faUser,
  faBook,
  faBug,
  faCog,
  faEye,
  faKey,
  faPen,
  faTag,
]

export const installedIcons = [
  ...brandIcons.map((icon) => ['fab', icon.iconName]),
  ...solidIcons.map((icon) => icon.iconName),
  ...regularIcons.map((icon) => ['far', icon.iconName]),
]

library.add(...brandIcons, ...solidIcons, ...regularIcons)

export default FontAwesomeIcon
